import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=649deded&scoped=true"
import script from "./InputRadioGroup.vue?vue&type=script&lang=js"
export * from "./InputRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./InputRadioGroup.vue?vue&type=style&index=0&id=649deded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649deded",
  null
  
)

export default component.exports